import React from 'react';
import MultipleComponentsLoader from '@/common/components/loaders/MultipleComponentsLoader';

function PendingLiveStreamItem() {
    return <div className="live-streams-item-pending wave-animation" />;
}

function PendingLiveStreams() {
    return (
        <div className="live-streams-wrap pending">
            <MultipleComponentsLoader itemsCount={5} componentLoader={PendingLiveStreamItem} />
        </div>
    );
}

export default PendingLiveStreams;
